import { Api } from '@axiom/ui';
import type {
  Candidate,
  Experience,
  ExperienceEdit,
  ExperienceTaxonomy,
  ExperienceTaxonomyFocusArea,
  ExperienceTaxonomyLegalSkill,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class ExperienceApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  async createExperience(
    candidateId: Candidate['id'],
    experience: Partial<ExperienceEdit>
  ) {
    return super.write<{ data: Experience }>({
      endpoint: `/candidates/${candidateId}/experiences`,
      body: experience,
      method: 'POST',
    });
  }

  async updateExperience(
    id: Experience['id'],
    experience: Partial<ExperienceEdit>
  ) {
    return super.write<{ data: Experience }>({
      endpoint: `/experiences/${id}`,
      body: experience,
      method: 'PATCH',
    });
  }

  async deleteExperience(id: Experience['id']) {
    return super.write<{ data: Experience }>({
      endpoint: `/experiences/${id}`,
      method: 'DELETE',
    });
  }

  async updateCandidateExperienceTaxonomy(
    candidateId: Candidate['id'],
    id: Experience['id'],
    experienceTaxonomy: ExperienceTaxonomy[]
  ) {
    return super.write<{ data: { experienceTaxonomy: ExperienceTaxonomy[] } }>({
      endpoint: `/candidates/${candidateId}/experiences/${id}/taxonomy`,
      method: 'PUT',
      body: { experienceTaxonomy },
    });
  }

  async createExperienceFocusAreaPredictions(id: Experience['id']) {
    return super.write<{ data: ExperienceTaxonomyFocusArea[] }>({
      endpoint: `/experiences/${id}/suggestedFocusAreas`,
      method: 'POST',
    });
  }

  async createExperienceLegalSkillPredictions(id: Experience['id']) {
    return super.write<{ data: ExperienceTaxonomyLegalSkill[] }>({
      endpoint: `/experiences/${id}/suggestedLegalSkills`,
      method: 'POST',
    });
  }
}

export const ExperienceApi = new ExperienceApiClass();
